import * as React from 'react';
import { useContext } from 'react';
import { MapStopDto } from '../../../../../../api/UnitMap';
import { MapContext } from '../../../../../common/UnitMap/UnitMapTypes';
import StopConfiguration from './StopConfiguration';
import '../../../../../../styles/UnitMapConfiguration.css';
import Button from '../../../../../common/form/Button';
import { Container } from 'reactstrap';
import { LoadingDisplay } from '../../../../../common/LoadingOverlay';

interface Props {
    onStopEdit: (index: number | undefined) => void;
}
const StopListEditor = (props: Props) => {
    const context = useContext(MapContext);

    const handleStopChanged = (index: number, stopConfig?: MapStopDto) => {
        let newStops = context.configuration.stops;
        props.onStopEdit(undefined);
        if (stopConfig === undefined) {
            //remove stop at index
            newStops.splice(index, 1);
            //shuffle stop numbers down for remaining stops
            newStops.forEach(s => {
                if (s.stopNumber > index) {
                    s.stopNumber--;
                }
            });
        } else {
            context.selectFloor(stopConfig.floor);
            newStops[index] = stopConfig;
        }

        context.setConfiguration({ ...context.configuration, stops: newStops });
    };

    const handleStopReorder = (moveUp: boolean, index: number) => {
        let newStops = context.configuration.stops;
        props.onStopEdit(undefined);
        //Remove stop at specified index
        let stopToMove = newStops.splice(index, 1)[0];
        if (moveUp) {
            //swap stop numbers between removed stop and previous stop in list
            stopToMove.stopNumber = index - 1;
            newStops[index - 1].stopNumber = index;
            //insert stop above previous stop
            newStops.splice(index - 1, 0, stopToMove);
        } else {
            //swap stop numbers between removed stop and next stop in list
            stopToMove.stopNumber = index + 1;
            newStops[index].stopNumber = index;
            //insert stop after next stop
            newStops.splice(index + 1, 0, stopToMove);
        }
        context.setConfiguration({ ...context.configuration, stops: newStops });
    };

    const handleStopAdded = () => {
        props.onStopEdit(undefined);
        if (!context.allFloors) {
            return;
        }
        let newStops = context.configuration.stops;
        let count = newStops.length;
        let newStop: MapStopDto = {
            directions: '',
            description: '',
            x: 1,
            y: 1,
            floor: context.allFloors[0].value,
            stopNumber: count - 1,
            isAmenity: false
        };
        //insert new stop before tour end
        newStops.splice(count - 1, 0, newStop);
        //set tour end stop number to last stop
        newStops[count].stopNumber = count;
        context.setConfiguration({ ...context.configuration, stops: newStops });
    };

    const stopHeader = (index: number, count: number): string => {
        if (index === 0) {
            return 'Tour Start';
        }
        if (index === count - 1) {
            return 'Tour End';
        }
        return `Stop ${index}`;
    };
    let numStops = context.configuration.stops.length;
    return (
        <div className="d-flex flex-column">
            <h4>Map Stops</h4>
            <Container className="editor-container">
                {context.configuration.stops && context.allFloors ? (
                    context.configuration.stops.map((stop, index) => {
                        return (
                            <div key={index}>
                                <h5>{stopHeader(index, numStops)}</h5>
                                <StopConfiguration
                                    isFirst={index === 0}
                                    isLast={index === numStops - 1}
                                    stop={stop}
                                    isEditing={false}
                                    onEditStop={() => props.onStopEdit(index)}
                                    onStopChanged={newConfig => {
                                        handleStopChanged(index, newConfig);
                                    }}
                                    onReorder={moveUp => {
                                        handleStopReorder(moveUp, index);
                                    }}
                                    floorList={context.allFloors}
                                />
                            </div>
                        );
                    })
                ) : (
                    <LoadingDisplay />
                )}
            </Container>
            {context.configuration.stops && context.allFloors && (
                <Button
                    text="Add Stop"
                    onClick={() => {
                        return handleStopAdded();
                    }}
                />
            )}
        </div>
    );
};

export default StopListEditor;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/unitMapControls/StopListEditor.tsx